import debounce from 'lodash.debounce';
import {ConnectedComponent} from 'lowkey-component';

import {createNavState} from '@services/NavState';
import {appSelectors} from '@store/appSlice';
import {navSelectors} from '@store/navSlice';

export class Body extends ConnectedComponent {
  private scrollY = 0;
  private state = createNavState();
  private isShowHeaderNavMenu = false;
  private isScrollStop = false;

  constructor(element: HTMLElement) {
    super(element);
    this.onScroll = debounce(this.onScroll, 30);
  }

  didMount() {
    window.addEventListener('scroll', this.onScroll);

    this.observe(navSelectors.selectIsShowHeaderNavMenu, (isShow) => {
      this.isShowHeaderNavMenu = isShow;
    });
    this.observe(appSelectors.selectIsScrollStop, (isScrollStop) => {
      this.isScrollStop = isScrollStop;
    });
  }

  didUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll = () => {
    if (this.isShowHeaderNavMenu || this.isScrollStop) {
      return;
    }
    const {scrollY, innerHeight} = window;
    if (this.scrollY != scrollY) {
      if (scrollY < 50) {
        this.state.updateHeaderNavDisplayState(undefined);
      } else {
        this.scrollY < scrollY
          ? this.state.updateHeaderNavDisplayState('hide')
          : this.state.updateHeaderNavDisplayState('show');
      }
      this.scrollY = scrollY;
    }
  };
}
